// import { useEffect } from "react";
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import SignatureCanvas from 'react-signature-canvas';
import html2canvas from 'html2canvas';
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { useEffect, useRef, useState } from "react";
import { useMemo } from "react";
import SignEncounter from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/Components/SignEncounter"
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import { ServerRequestPublic } from '../../../../utils/ServerDataRequest';
import { enumUtil } from '../../../../utils/Enum';
import NotificationHandler from '../../../../utils/NotificationHandler';

const Signature = ({ item, setItem, formData, setFormData, activeAccordion, validations, ...props }) => {
    const { patientName = 'Patient',
        // activeTab, setActiveTab, 
        // setSearchParam, 
        // setIsSign, 
        // setIsLoading, 
        // getSaveData
    } = props;
    const { setItemWithFile, handleRemoveFile, handleSetSelectedDateSign } = useNewItemChange(setItem, 'Viewer', activeAccordion);

    console.log("idxaa", item.ItemID)
    const [isSign, setIsSign] = useState(false);
    const [isSignImage, setIsSignImage] = useState(false);


    const loadSignatureFromServer = async (path) => {
        try {
            const response = await ServerRequestPublic(
                enumUtil.controller.Wasabi + "/DownloadFile",
                'post',
                { BucketPath: path },
                "Download"
            );
            if (response.type === "application/png" || response.type === "application/jpg" || response.type === "application/jpeg") {
                const blob = response;
                const objectURL = URL.createObjectURL(blob);
                setIsSignImage(objectURL);
            } else {
                NotificationHandler("Unsupported signature format", enumUtil.enumtoaster.error);
            }
        } catch (error) {
            NotificationHandler("Failed to load signature", enumUtil.enumtoaster.error);
        }
    };

    useEffect(() => {
        if (formData?.IsDefaultSignature && formData?.SignaturePath) {
            loadSignatureFromServer(formData.SignaturePath);
        }
    }, [formData?.IsDefaultSignature, formData?.SignaturePath]);

    const handleRemoveFileDefault = () => {
        setIsSignImage(null);
        setFormData(prev => ({ ...prev, SignaturePath: '', IsDefaultSignature: false }));
    };

    return (
        <>
            <SignEncounter
                isSign={isSign}
                setIsSign={setIsSign}
                // providerName={initialData?.Data?.ProviderFirstName || '' } 
                providerName={patientName} // Patient Name
                setSearchParam={() => { }}
                getSaveData={setItemWithFile}
                item={item}
                isOpenedFrom={'PatientDefaultSignature'}
            />
            <div className='content-box d-flex gap-10'>
                <p className={`text text-black min-w-231px d-flex justify-content-end gap-01 text-end  ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
                    {item.content || '[Enter prompt or question]'}
                    {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>}
                </p>
                {formData?.IsDefaultSignature ?
                    <div className="position-relative sign-here-box cursor-pointer d-flex align-items-center justify-content-center w-100">
                        <img
                            src={isSignImage || ''}
                            style={{ maxHeight: '81px' }}
                            alt="Uploaded preview" />
                        <span className="cross-icon d-flex" onClick={handleRemoveFileDefault}>
                            <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                        </span>
                    </div>
                    :
                    <div className="position-relative sign-here-box cursor-pointer d-flex align-items-center justify-content-center w-100">
                        {item.file ?
                            <>
                                <img
                                    src={`data:image/png;base64,${item.file}`}
                                    style={{ maxHeight: '81px' }}
                                    alt="Uploaded preview" />
                                <span className="cross-icon d-flex" onClick={() => handleRemoveFile(item)}>
                                    <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                                </span>
                            </>
                            :
                            <div className='fs-13 ar-light-color text h-100 w-100 d-flex justify-content-center align-items-center' onClick={() => setIsSign(true)}>Sign here</div>}
                    </div>
                }

            </div>
        </>
    );
};

export default Signature